import { Component, Input } from '@angular/core';

@Component({
  selector: 'cosmos-element-preview',
  templateUrl: './element-preview.component.html',
  styleUrls: ['./element-preview.component.scss'],
})
export class ElementPreviewComponent {
  @Input() public element: any;
  @Input() public isCompact = true;
}
